import '@fontsource-variable/inter';
import React, { useEffect } from 'react';
import './App.css';
import Router from './Routes/Router';
import { fetchAndCacheServerHash } from './Utils/version'; // Claude: cache server hash on load 28-03-2026
import SessionTerminatedModal from './Components/Common/SessionTerminatedModal'; // Claude: graceful session kick modal 18-04-2026

function App() {
  // Claude: fire-and-forget — fetches server commit hash and stores in localStorage 29-03-2026
  useEffect(() => {
    fetchAndCacheServerHash();
  }, []);

  return (
    <>
      <Router/>
      <SessionTerminatedModal />
    </>
  );
}

export default App;
